// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "controls-xbLB2";
var _4 = "controls__item-15Wnz";
var _5 = "controls__img-1JI3Y";
export { _1 as "__esModule", _2 as "mobile", _3 as "controls", _4 as "controls__item", _5 as "controls__img" }
export default { "__esModule": _1, "mobile": _2, "controls": _3, "controls__item": _4, "controls__img": _5 }
